export const format_distance = (d) => {
    let distance = d < 100 ? parseFloat(d.toPrecision(2)) : parseFloat(d.toPrecision(3));
    if (distance < 1000) {
        return `${distance} m`;
    } else {
        return `${parseFloat((distance / 1000).toPrecision(3))} km`;
    }
};

export default {format_distance};
